import React from "react";

import ApiService from "../../../../../../services/ApiService";
import translate from "../../../../../../services/Translate";
import { TutorFormPayload } from "./TutorFormModal.d";

export const fetchUserTutorredCohortSkillBlocks = (
  userId: number,
  cohortId: number,
  language: string,
  setSkillBlocks: Function,
  setLoading: Function
) => {
  setLoading(true);

  ApiService.get(`users/${userId}/tutors/cohorts/${cohortId}/skill-blocks`)
    .then((response) => setSkillBlocks(response.data.cohort_skill_blocks))
    .catch((error) => {
      console.error("An error occurred while fetching user's cohort skill blocks", error);
      alert(translate(language, "PAGES.USER.TUTOR.SKILL_BLOCK_FORM.ERROR"));
    })
    .finally(() => setLoading(false));
};

export const saveUserTutorredCohortForm = (
  userId: number,
  cohortId: number,
  payload: TutorFormPayload,
  language: string,
  setSaving: Function,
  onSubmitted: Function,
  showAlert?: Function,
  popAlert?: Function
) => {
  setSaving(true);

  ApiService.post(`users/${userId}/tutors/cohorts/${cohortId}/forms`, payload)
    .then(() => {
      alert(translate(language, "PAGES.USER.TUTOR.SKILL_BLOCK_FORM.SUCCESS"));
      onSubmitted();
    })
    .catch((error: any) => {
      console.error("An error occurred while saving user's tutoring form", error);
      showAlert?.({
        type: "danger",
        title: translate(language, "PAGES.USER.TUTOR.SKILL_BLOCK_FORM.SAVE_ERROR_TITLE"),
        message: error?.data?.message || translate(language, "PAGES.USER.TUTOR.SKILL_BLOCK_FORM.SAVE_ERROR"),
        buttons: [
          {
            label: translate(language, "GLOBAL.CLOSE"),
            variant: "danger",
            onClick: () => popAlert?.(),
          },
        ],
        extraContent: error?.data ? (
          <pre className="text-start off-white-background p-2 rounded border">
            {JSON.stringify(error.data, null, 2)}
          </pre>
        ) : null,
      });
    })
    .finally(() => setSaving(false));
};
